import { IncomingMessage } from 'http';

import { navParams } from '@/config/nav/paramConfig';
import { graphql } from '@/graphql/__generated/gql';
import type { NavQueryVariables } from '@/graphql/__generated/gql/graphql';
import { FullUser } from '@/graphql/__generated/resolvers-types';
import { getParamsFromObject } from '@/utils/getParamsFromObject';
import { prefetchRequest, useRequest } from '@/utils/request';

const cacheKey = 'nav-by-id';
const query = graphql(/* GraphQL */ `
    query nav($id: ID, $extraParams: UserParams!) {
        nav(ID: $id, extraParams: $extraParams) {
            globalMenu {
                topNav {
                    id
                    locale
                    href
                    label
                    type
                    items {
                        id
                        label
                        type
                        href
                        locale
                    }
                }
                footerNav {
                    id
                    label
                    href
                    type
                    locale
                    slug
                    items {
                        id
                        label
                        type
                        href
                        locale
                        slug
                    }
                }
            }
        }
    }
`);

const useGetNav = (user: FullUser | null, id?: string | number) => {
    const userParams = user ? getParamsFromObject(user, navParams) : {};

    const { data, isError } = useRequest({
        cacheKey,
        query,
        dataParams: {
            id: id ?? null,
            extraParams: {
                ...userParams,
            },
        } as NavQueryVariables,
        appName: 'app-shell',
    });

    return {
        nav: data?.nav?.globalMenu,
        isError,
    };
};

// Used with getServerSideProps
const prefetchGetNav = (
    req: IncomingMessage,
    id?: string | number,
    extraParams?: Record<string, unknown> | null,
) => {
    return prefetchRequest({
        cacheKey,
        query,
        dataParams: {
            id: id ?? null,
            extraParams: {
                ...(extraParams ?? {}),
            },
        } as NavQueryVariables,
        appName: 'app-shell',
        req,
    });
};

export { useGetNav as default, prefetchGetNav };
